module.exports = __webpack_public_path__ + "img/icon-user.3205d086.svg";